<template>
  <div>
    <div
      v-if="hasLoad"
      v-touch="{
        down: () => swipe('down'),
        start: () => swipe('start'),
        end: () => swipe('end'),
      }"
    >
      <div class="pt-05 mt-1 px-md-5 row pb-16">
        <div
          v-for="(load, index) in loads.list"
          :key="index"
          class="col-12 py-0"
        >
          <LoadCard :load="load"></LoadCard>
        </div>
      </div>

      <loading v-if="loads.loading" class="mb-6"></loading>
    </div>

    <div
      v-else
      class="h-half-screen d-flex justify-center align-center"
      v-touch="{
        down: () => swipe('down'),
        start: () => swipe('start'),
        end: () => swipe('end'),
      }"
    >
      <div>
        <loading v-if="loads.loading"></loading>
        <div v-else class="text-center font-xsmall grey--text text-darken-2">
          <svg-icon name="notice"></svg-icon>
          <div class="mt-8">شما سفارش ندارید</div>
          <div>
            دکمه <span class="logistic--text">اعلام بار جدید</span> را بزنید و
            سفارش خود را ثبت کنید.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LoadCard = () => import("./LoadCard.vue");

export default {
  name: "LogisticLoadsList",
  components: {
    LoadCard,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    refreshList: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loads: {
        list: [],
        counter: 0,
        loading: false,
        hasMoreLoad: true,
      },
      startSwipingPosition: 0,
      endSwipingPosition: 0,
    };
  },
  computed: {
    hasLoad() {
      return !!this.loads.list.length;
    },
  },
  methods: {
    async getLoads() {
      this.loads.loading = true;

      const counter = this.loads.counter;
      const data = this.calcRequestData();
      const res = await this.$parseSDK.Cloud.run(data.url, data.params).catch(
        (err) => this.handleLoadsErr(err)
      );

      if (res) this.setLoads(res, counter);

      this.loads.loading = false;
    },
    calcRequestData() {
      const statusList = [];

      switch (this.type) {
        case "current":
          [
            "submitted",
            "validator_accepted",
            "driver_waiting",
            "driver_was_found",
            "waybill_uploaded",
            "waybill_accepted",
            "loaded",
          ].forEach((item) => statusList.push(item));
          break;

        case "deliver":
          statusList.push("delivered");
          break;

        case "cancel":
          statusList.push("canceled");
          break;
      }

      return {
        url: "get_company_loads_by_company",
        params: {
          load_status: statusList,
          skip_number: this.loads.list.length,
          companyId: localStorage.getItem("companyId"),
        },
      };
    },
    setLoads(res, counter) {
      // check request counter
      if (counter !== this.loads.counter) return;

      const list = res.loads;

      if (list && list.length) {
        // set loads, increase counter

        list.forEach((load) => {
          let finalLoad = JSON.parse(JSON.stringify(load));
          const extraData = this.getExtraData(finalLoad);
          Object.assign(finalLoad, extraData);

          this.loads.list.push(finalLoad);
        });
        this.loads.counter++;

        if (list.length < 10) {
          // no any more load exist after this list
          this.loads.hasMoreLoad = false;
        }
      } else {
        // no any more loads exist
        this.loads.hasMoreLoad = false;
      }
    },
    getExtraData(load) {
      return {
        formattedCreatedAt: this.$utils.formatCreatedAt(load.createdAt),
      };
    },
    handleLoadsErr(error) {
      const code = error.message;
      const commonErr = this.$utils.handleErrorIfKnown(code);
      if (commonErr) return;

      let msg = "دریافت بارها با خطا مواجه شد";

      this.$store.commit("showSnackbar", {
        text: msg,
      });
    },
    checkScroll() {
      // add scrolling event to load more when scrolled down
      const scrolledHeight = Math.ceil(
        document.documentElement.scrollTop + window.innerHeight
      );
      const offsetHeight = document.documentElement.offsetHeight;
      const bottomOfWindow = scrolledHeight === offsetHeight;

      if (bottomOfWindow) {
        const loading = this.loads.loading;
        const hasMoreLoad = this.loads.hasMoreLoad;

        if (!loading && hasMoreLoad) this.getLoads();
      }
    },
    swipe(dir) {
      switch (dir) {
        case "down":
          // swiped down
          this.checkRefresh();
          break;

        case "start":
          // start swiping
          this.startSwipingPosition = document.documentElement.scrollTop;
          break;

        case "end":
          // end swiping
          this.endSwipingPosition = document.documentElement.scrollTop;
          break;
      }
    },
    checkRefresh() {
      // refresh list if user swiped down from top of page

      // check if is on top of page
      if (this.startSwipingPosition === 0 && this.endSwipingPosition === 0)
        this.refresh();
    },
    refresh() {
      this.loads = {
        list: [],
        counter: 0,
        loading: false,
        hasMoreLoad: true,
      };

      this.getLoads();
    },
  },
  mounted() {
    this.refresh();
  },
  activated() {
    // add scroling event for list
    window.addEventListener("scroll", this.checkScroll);

    if (!this.hasLoad && this.loads.counter === 0) {
      // there is no loads exist in list, so refresh list
      this.refresh();
    }
  },
  deactivated() {
    // remove scroling event for list
    window.removeEventListener("scroll", this.checkScroll);
  },
  watch: {
    refreshList(val) {
      if (val) this.refresh();
    },
  },
};
</script>

<style scoped>
.h-75 {
  height: 75vh;
}
.h-half-screen {
  height: calc(100vh - 120px);
}
</style>
